import type { FeatureGroup } from '../../../types';
import { PAYMENTS_FEATURE_GROUP } from '../group';

export const PAYMENTS_ACTIVITY_FEATURE_GROUP: FeatureGroup = {
  guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f06ff',
  name: 'payments_activity',
  description: 'The payments activity feed',
  product: 'payments',
  parentGuid: PAYMENTS_FEATURE_GROUP.guid,
};
